module.exports = __webpack_public_path__ + "static/media/katheryn-winnick-win.c30376a5.jpg";